import React, { useState, useEffect } from "react";
import w2 from "../assets/images/12.png";

export default function Skills() {
  const [inView, setInView] = useState(false);

  const handleScroll = () => {
    const skillsElement = document.getElementById("skills");
    if (!skillsElement) return;

    const skillsPosition = skillsElement.getBoundingClientRect();
    const skillsTop = skillsPosition.top;
    const skillsBottom = skillsPosition.bottom;

    setInView(skillsTop < window.innerHeight && skillsBottom >= 0);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section id="skills" className="py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Section */}
          <div className="col-lg-6">
            <h2 className=" display-6 fw-bold my-4"style={{ color: "orangered" }}>Continuous Skill Growth</h2>
          
          

            {/* Single-column Skills */}
            <div className="mb-4">
              <h5 className="fw-bold mb-2">Mobile Development</h5>
              <p className="text-muted" style={{ fontSize: "15px" }}>
                I design scalable Flutter apps with smooth UI and efficient
                Firebase integration, ensuring performance across devices.
             
                          <p style={{textAlign:"right"}}className="fw-bold ">90%</p>
 </p>
              <div className="skill-container mb-3">
                <div
                  className="bar_in"
                  style={{
                    width: inView ? "90%" : "0%",
                    backgroundColor: "rgb(227, 76, 0)",
                    height: "8px",
                    transition: "width 1s ease",
                  }}
                ></div>
              </div>
            </div>

            <div className="mb-4">
              <h5 className="fw-bold mb-2">MERN / PERN Stack</h5>
              <p className="text-muted" style={{ fontSize: "15px" }}>
                I build full-stack apps with clean code, reusable components,
                and RESTful APIs, maintaining performance and scalability.
              
                          <p style={{textAlign:"right"}}className="fw-bold ">90%</p>
</p>
              <div className="skill-container mb-3">
                <div
                  className="bar_in"
                  style={{
                    width: inView ? "90%" : "0%",
                    backgroundColor: "rgb(38, 175, 38)",
                    height: "8px",
                    transition: "width 1s ease",
                  }}
                ></div>
              </div>
            </div>

            <div className="mb-4">
              <h5 className="fw-bold mb-2">UI/UX Design (Figma)</h5>
              <p className="text-muted" style={{ fontSize: "15px" }}>
                I translate ideas into clean interfaces that prioritize usability,
                user psychology, and visual flow through Figma.
             
              <p style={{textAlign:"right"}}className="fw-bold ">80%</p>
             </p>  <div className="skill-container mb-3">
                <div
                  className="bar_in"
                  style={{
                    width: inView ? "80%" : "0%",
                    backgroundColor: "rgb(51, 21, 96)",
                    height: "8px",
                    transition: "width 1s ease",
                  }}
                ></div>
              </div>
            </div>
          </div>
<div className="col-lg-1"> </div>
          {/* Right Section */}
          <div className="col-lg-5 text-center mt-5 mt-lg-0">
            <img src={w2} alt="Skills Illustration" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>
  );
}
